module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "saying grace",
      "src": "images/image-120.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "booktitle"
  }, [_vm._v("Saying Grace")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Blessings "), _c('em', [_vm._v("for the")]), _vm._v(" Family Table")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', [_vm._v("Edited by")]), _vm._v(" Sarah McElwain")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', [_vm._v("Illustrations by")]), _vm._v(" David Dean")]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Saying Grace Chronicle Books",
      "src": "images/logo.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac32e732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002titlepage.vue
// module id = 60
// module chunks = 0